import React from 'react';
import { Link } from 'react-router-dom';

import { useUser } from '../contexts/UserContext';
import styles from '../assets/styles/Devlink.module.scss';

const Devlink: React.FC = () => {
  const { user, loading } = useUser();

  if (loading) return null;

  if (!user || !user.is_admin) {
    return (
      <main className={styles.notFoundPage}>
        <p className={styles.notFoundCode}>404</p>
        <h1>ページが見つかりません</h1>
      </main>
    );
  }

  return (
    <main className={styles.devlinkPage}>
      <h1>検証リンクリスト</h1>
      <ul>
        <li><Link to="/board-v2">AI診断 V2</Link></li>
      </ul>
    </main>
  );
};

export default Devlink;
